<template>
    <div class="order-steps">
        <span :class="['step-lines', { active: active != 2 && active != 1 }]">
            <span :class="['step-text', { active: active == 2 }]">{{
                $t(steps[0])
            }}</span>
            <span :class="['on-active', { active: active == 2 }]"></span>
        </span>
        <span
            :class="[
                'step-lines',
                { active: active != 13 && active != 2 && active != 1 },
            ]"
        >
            <span :class="['step-text', { active: active == 13 }]">
                {{ $t(steps[1]) }}
            </span>
            <span :class="['on-active', { active: active == 13 }]"></span>
        </span>

        <span
            :class="[
                'step-lines',
                { active: active != 13 && active != 2 && active != 1 },
            ]"
        >
            <span class="step-text">
                {{ $t(steps[2]) }}
            </span>
        </span>

        <span
            :class="[
                'step-lines',
                'line-end',
                { active: active == 10 },
                { delivered: active == 10 },
            ]"
        >
            <span :class="['step-text', { active: active == 4 }]">
                {{ $t(steps[3]) }}
            </span>
            <span :class="['step-text-end', { active: active == 10 }]">
                {{ $t(steps[4]) }}
            </span>
            <span :class="['on-active', { active: active == 4 }]"></span>
            <span :class="['on-active-end', { active: active == 10 }]"></span>
        </span>
    </div>
</template>

<script>
export default {
    props: ["active"],
    data() {
        return {
            steps: [
                "Shipment under reviewing",
                "Labels placed",
                "Shipment picked-up",
                "In-transit",
                "Delivered",
            ],
            // draft will disabled
            // reviewing-2  , waiting for -pickup - 13 ,------------ in-transit - 4, in-transit - 4, delivered -10
        };
    },
};
</script>

<style lang="scss" scoped>
.order-steps {
    .step-text,
    .step-text-end {
        display: inline-block;
        position: absolute;
        width: 120px;
        color: #adb5bd;
    }

    .step-lines {
        display: inline-block;
        position: relative;
        height: 2px;
        min-width: 200px;
        background-color: #eef2f7;
        transition: 0.4s linear;

        &::before {
            display: block;
            position: absolute;
            background-color: #727cf5;
            box-sizing: content-box;
            border: 0.25em solid #fafbfe;
            content: "";
            height: 8px;
            width: 8px;
            border-radius: 50%;
            left: -4px;
            top: -7px;
            z-index: 5;
        }

        .step-text {
            transition: 0.4s linear;
            top: 10px;
            left: -60px;
        }

        .step-text.active {
            color: #727cf5;
        }

        .on-active {
            display: block;
            position: absolute;
            background-color: #727cf5;
            content: "";
            height: 32px;
            width: 32px;
            border-radius: 50%;
            left: 4px;

            top: 1px;
            z-index: 7;
            opacity: 0;
            animation-iteration-count: infinite;
            animation-duration: 2s;
            animation-timing-function: ease-out;
        }

        .on-active.active {
            animation-name: blink;
        }
    }

    .line-end {
        &::after {
            display: block;
            position: absolute;
            background-color: #0acf97;
            box-sizing: content-box;
            border: 0.25em solid #fafbfe;
            content: "";
            height: 8px;
            width: 8px;
            border-radius: 50%;
            right: -4px;
            top: -7px;
            z-index: 5;
        }

        .on-active-end {
            display: block;
            position: absolute;
            background-color: #0acf97;
            content: "";
            height: 32px;
            width: 32px;
            border-radius: 50%;
            right: -28px;
            top: 1px;
            z-index: 7;
            opacity: 0;
            animation-iteration-count: infinite;
            animation-duration: 2s;
            animation-timing-function: ease-out;
        }

        .on-active-end.active {
            animation-name: blink;
        }

        .step-text-end {
            transition: 0.4s linear;
            top: 10px;
            right: -60px;
        }

        .step-text-end.active {
            color: #0acf97;
        }
    }

    .step-lines.active {
        background-color: #727cf5;
    }

    .step-lines.active.delivered {
        background-color: #0acf97;
    }
}

@keyframes blink {
    0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0;
    }
}
</style>
